import type { Prospect } from "@shared/schema";
import { contactFields } from "@shared/wa-contact";
import { waDigits } from "@shared/whatsapp";

/** Vrai si l'extension Chrome `chrome-extension/` tourne sur cette page (elle pose ce marqueur). */
export function waExtensionReady(): boolean {
  return document.documentElement.dataset.pwrcWa === "1";
}

/**
 * Confie la confirmation à l'extension : conversation WhatsApp Web ouverte avec le message rempli,
 * contact enregistré, ajout à la liste. L'envoi reste au clic de Christophe. Faux si le numéro est douteux.
 */
export function sendConfirmationToExtension(
  prospect: Pick<Prospect, "firstName" | "lastName" | "email" | "phone">,
  text: string,
): boolean {
  const phone = waDigits(prospect.phone);
  if (!phone) return false;
  window.postMessage(
    { type: "PWRC_WA_CONFIRM", job: { phone, text, contact: contactFields(prospect) } },
    window.location.origin,
  );
  return true;
}
